/* Play-to-unlock for the Christmas Monster Set card.
   Locks the set card behind a 15-second "Catch Neon Jack" game; a win unlocks add-to-cart on this device
   for a real 5-minute window (it locks again at 0:00, and they can replay).
   Config comes from window.MMU (set by the page). If anything is missing it does nothing. */
(function () {
  var C = window.MMU || {};
  if (!C.enabled) return;
  var KEY = 'mmu_set_unlocked_v1'; // win timestamp; the product-page lock reads the same key
  var GOAL = C.goal || 7, SECONDS = C.seconds || 15, PENALTY = 2;
  var KEEP = (C.keepMinutes || 5) * 60e3;
  var IMG = C.img || {};
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var attempts = 0, card, cta, modal, lastFocus, ticker, soldShown = false;
  var LOCK_SVG = '<svg viewBox="0 0 40 48" width="30" height="36" aria-hidden="true"><path class="sh" d="M11 22v-8a9 9 0 0 1 18 0v8" fill="none" stroke="#1c1b1a" stroke-width="5" stroke-linecap="round"/><rect x="5" y="21" width="30" height="24" rx="6" fill="#1c1b1a"/><circle cx="20" cy="32" r="3.5" fill="#b6ff3b"/></svg>';

  function track(name, data) {
    data = data || {};
    // only the published theme reports; draft previews and local tests just log.
    // PostHog (project 452362) is the one that records: the Meta pixel runs as a sandboxed web pixel, so window.fbq is absent
    var live = !C.dryRun && !(window.Shopify && Shopify.theme && Shopify.theme.role !== 'main');
    if (live) {
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
      try { if (window.posthog && posthog.capture) posthog.capture(name, data); } catch (e) {}
      try { if (window.fbq) fbq('trackCustom', name, data); } catch (e) {}
    }
    if (C.debug || !live) console.log('[mmu]', name, data);
  }
  function left() {
    try { var t = +localStorage.getItem(KEY); return t ? Math.max(0, KEEP - (Date.now() - t)) : 0; } catch (e) { return 0; }
  }
  function unlocked() { return left() > 0; }
  function mmss(ms) { var s = Math.ceil(ms / 1000); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  // one ticker drives every countdown on the page; at 0:00 the set locks again
  function startTicker() {
    if (ticker) return;
    ticker = setInterval(function () {
      var ms = left();
      [].forEach.call(document.querySelectorAll('[data-mmu-left]'), function (n) { n.textContent = mmss(ms); });
      [].forEach.call(document.querySelectorAll('.mmu-countdown'), function (n) { n.classList.toggle('is-low', ms > 0 && ms < 60e3); });
      if (ms <= 0) { clearInterval(ticker); ticker = null; expire(); }
    }, 500);
  }
  function expire() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    track('mm_unlock_expired', {});
    if (card) paintCard();
    if (modal && modal.classList.contains('is-open') && modal.querySelector('.mmu-win.is-on')) screen('expired');
  }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function stop(e) { e.preventDefault(); e.stopPropagation(); }

  /* ---------- card ---------- */
  function setText(root, from, to) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) if (n.nodeValue.trim().toLowerCase() === from) n.nodeValue = n.nodeValue.replace(/\S.*\S|\S/, to);
  }
  function paintCard() {
    if (soldShown) return;
    var on = unlocked();
    setText(card, on ? 'locked' : 'sold out', on ? 'Unlocked' : 'Locked');
    // when sets are in stock the card is selectable, so hold it shut until this device wins
    var radio = card.querySelector('input[type="radio"]');
    if (radio && C.sellable) { radio.disabled = !on; card.classList.toggle('mmu-held', !on); }
    var status = [].find.call(card.querySelectorAll('div'), function (d) { return /numbered set is taken|catch neon jack|yours to grab/i.test(d.textContent) && d.children.length <= 1; });
    if (status) status.innerHTML = on ? '<strong>Unlocked</strong> · yours for <span data-mmu-left>' + mmss(left()) + '</span>' : '<strong>Locked</strong> · ' + (C.lockedLine || 'catch Neon Jack to unlock one');
    if (cta) cta.remove();
    cta = el('div', 'mmu-cta' + (on ? ' is-unlocked' : ''));
    cta.innerHTML =
      (on ? '<div class="mmu-cta__art mmu-cta__art--set"><img src="' + (IMG.set || IMG.jack) + '" alt=""><i>🔓</i></div>'
          : '<div class="mmu-cta__art"><img src="' + IMG.jack + '" alt=""><i>🔒</i></div>') +
      '<div class="mmu-cta__copy"><b>' + (on ? 'Unlocked. Yours for <span data-mmu-left>' + mmss(left()) + '</span>' : 'Locked. Play to unlock.') + '</b>' +
      '<span>' + (on ? 'You unlocked the Christmas Monster Set. Grab it before it locks again.' : 'Catch Neon Jack ' + GOAL + ' times in ' + SECONDS + ' seconds and the set is yours to buy.') + '</span></div>' +
      '<button type="button" class="mmu-btn' + (on ? '' : ' mmu-btn--pulse') + '">' + (on ? 'Add to cart · ' + (C.price || '$199') : '🔓 Play to unlock') + '</button>';
    var anchor = status || card.lastElementChild;
    anchor.parentNode.insertBefore(cta, anchor.nextSibling);
    cta.addEventListener('click', stop);
    cta.querySelector('.mmu-btn').addEventListener('click', function (e) {
      stop(e);
      if (unlocked()) addToCart(this, 'card'); else open();
    });
    if (on) startTicker(); else unpickSet();
  }

  /* ---------- the offer block's own buttons ---------- */
  // The theme's <blind-box-offer> picks a card on any tap, ?offer= link or [data-offer-pick] link (it only skips
  // cards with .is-sold, not disabled radios), and its Check availability / sticky buttons buy whatever is picked.
  // So while the set is locked, picking it or buying it from the page opens the game instead.
  function guardOffer() {
    var offer = card.closest('blind-box-offer');
    if (!offer || offer.mmuGuard || typeof offer.pick !== 'function') return;
    offer.mmuGuard = true;
    var proto = Object.getPrototypeOf(offer);
    offer.pick = function (key, scroll) {
      if (key === card.dataset.card && soldShown) return;
      if (key === card.dataset.card && !unlocked()) { track('mm_unlock_blocked', { via: 'pick' }); open(); return; }
      return proto.pick.call(offer, key, scroll);
    };
    offer.onCta = function () {
      if (offer.current() === card && soldShown) { unpickSet(); return; }
      if (offer.current() === card && !unlocked()) { track('mm_unlock_blocked', { via: 'buy_button' }); open(); return; }
      return proto.onCta.call(offer);
    };
    unpickSet();
  }
  // e.g. the page opened with ?offer=set, or the unlock just ran out while the set was picked
  function unpickSet() {
    var offer = card && card.closest('blind-box-offer');
    if (!offer || !offer.mmuGuard || (unlocked() && !soldShown) || offer.current() !== card) return;
    var other = (offer.cards || []).find(function (c) { return c !== card && !c.classList.contains('is-sold'); });
    if (other) Object.getPrototypeOf(offer).pick.call(offer, other.dataset.card, false);
  }

  /* ---------- modal ---------- */
  function build() {
    modal = el('div', 'mmu-modal');
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Catch Neon Jack to unlock the Christmas Monster Set');
    modal.innerHTML =
      '<div class="mmu-panel"><div class="mmu-snow"></div>' +
      '<div class="mmu-top"><span class="mmu-tag">🔒 Vault game</span><button type="button" class="mmu-x" aria-label="Close">×</button></div>' +
      // intro
      '<section class="mmu-screen mmu-intro">' +
        '<h2 class="mmu-h">Catch <em>Neon Jack</em>.<br>Unlock the set.</h2>' +
        '<p class="mmu-p">He’s hiding in the presents. Tap him ' + GOAL + ' times in ' + SECONDS + ' seconds and the Christmas Monster Set unlocks for you.</p>' +
        '<ul class="mmu-legend">' +
          '<li class="ok"><img src="' + IMG.jack + '" alt=""><span><b>Neon Jack · tap him</b>Each catch fills a light.</span></li>' +
          '<li class="no"><img src="' + IMG.lemmy + '" alt=""><span><b>Red Lemmy · leave her</b>Wrong monster costs you ' + PENALTY + ' seconds.</span></li>' +
          '<li class="no"><img src="' + IMG.medusa + '" alt=""><span><b>Red Medusa · leave her</b>Same deal: −' + PENALTY + ' seconds.</span></li>' +
        '</ul><div class="mmu-grow"></div>' +
        '<button type="button" class="mmu-btn mmu-go">Start the game</button>' +
        '<p class="mmu-fine">Free to play · keep trying until you catch him</p>' +
      '</section>' +
      // play
      '<section class="mmu-screen mmu-play">' +
        '<div class="mmu-hud"><div class="mmu-pips"></div><div class="mmu-time" aria-live="off"></div></div>' +
        '<div class="mmu-bar"><i></i></div>' +
        '<p class="mmu-hint">Tap <b>Neon Jack</b> · leave the red ones alone</p>' +
        '<div class="mmu-board" role="group" aria-label="Presents"></div>' +
        '<div class="mmu-count" aria-live="assertive"></div>' +
      '</section>' +
      // win: the set itself, stamped unlocked, with the real 5-minute window
      '<section class="mmu-screen mmu-result mmu-win">' +
        '<div class="mmu-vault"><img class="mmu-vault__img" src="' + (IMG.set || IMG.jack) + '" alt="The Christmas Monster Set: Red Lemmy, Red Medusa and Neon Jack">' +
          '<span class="mmu-vault__stamp">Unlocked</span><span class="mmu-vault__lock">' + LOCK_SVG + '</span></div>' +
        '<p class="mmu-tag">You caught Neon Jack ' + GOAL + ' times</p>' +
        '<h2 class="mmu-h">You unlocked the<br>Christmas Monster Set.</h2>' +
        '<p class="mmu-p">Red Lemmy, Red Medusa and a guaranteed Neon Jack, plus a surprise Nancy toy.</p>' +
        '<p class="mmu-price"><s>' + (C.was || '$546') + '</s> &nbsp;<b>' + (C.price || '$199') + '</b> &nbsp;· ships by 5 Dec</p>' +
        '<div class="mmu-countdown" role="timer"><span>Unlocked for</span><b data-mmu-left>' + mmss(KEEP) + '</b></div>' +
        '<button type="button" class="mmu-btn mmu-btn--pulse mmu-atc">Add to cart · ' + (C.price || '$199') + '</button>' +
        '<button type="button" class="mmu-btn mmu-btn--ghost mmu-later">Not now</button>' +
        '<p class="mmu-note" aria-live="polite"></p>' +
        '<p class="mmu-fine">When the timer hits 0:00, the set locks again.</p>' +
      '</section>' +
      // the last set went while this page was open
      '<section class="mmu-screen mmu-result mmu-soldout">' +
        '<div class="mmu-vault is-locked"><img class="mmu-vault__img" src="' + (IMG.set || IMG.jack) + '" alt=""><span class="mmu-vault__stamp">Sold out</span></div>' +
        '<p class="mmu-tag">Every set is taken</p>' +
        '<h2 class="mmu-h">Sold out for now.</h2>' +
        '<p class="mmu-p">Every Christmas Monster Set has been claimed, so there’s nothing left to unlock.</p>' +
        '<button type="button" class="mmu-btn mmu-close4">Back to the page</button>' +
      '</section>' +
      // the 5 minutes ran out with the game open
      '<section class="mmu-screen mmu-result mmu-expired">' +
        '<div class="mmu-vault is-locked"><img class="mmu-vault__img" src="' + (IMG.set || IMG.jack) + '" alt=""><span class="mmu-vault__stamp">Locked</span></div>' +
        '<p class="mmu-tag">Time’s up</p>' +
        '<h2 class="mmu-h">It locked again.</h2>' +
        '<p class="mmu-p">Your ' + Math.round(KEEP / 60e3) + ' minutes ran out. Catch Neon Jack again to unlock the set.</p>' +
        '<button type="button" class="mmu-btn mmu-again2">Play again</button>' +
        '<button type="button" class="mmu-btn mmu-btn--ghost mmu-close3">Maybe later</button>' +
      '</section>' +
      // lose
      '<section class="mmu-screen mmu-result mmu-lose">' +
        '<img class="mmu-hero" src="' + IMG.jack + '" alt="" style="filter:grayscale(.3) drop-shadow(0 0 20px rgba(182,255,59,.3))">' +
        '<p class="mmu-tag mmu-score"></p>' +
        '<h2 class="mmu-h">So close.</h2>' +
        '<p class="mmu-p">Jack’s slippery. Keep trying: he slows down a little every time.</p>' +
        '<button type="button" class="mmu-btn mmu-again">Try again</button>' +
        '<button type="button" class="mmu-btn mmu-btn--ghost mmu-close2">Maybe later</button>' +
      '</section></div>';
    document.body.appendChild(modal);
    var pips = modal.querySelector('.mmu-pips'), board = modal.querySelector('.mmu-board');
    for (var i = 0; i < GOAL; i++) pips.appendChild(el('span', 'mmu-pip', '<img src="' + IMG.jack + '" alt="">'));
    for (var j = 0; j < 9; j++) {
      var h = el('button', 'mmu-hole', '<span class="mmu-mon"><img alt="" draggable="false"></span><span class="mmu-box"></span>');
      h.type = 'button'; h.setAttribute('aria-label', 'Present ' + (j + 1)); h.dataset.i = j;
      h.addEventListener('pointerdown', hit); h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') hit.call(this, e); });
      board.appendChild(h);
    }
    modal.querySelector('.mmu-x').onclick = close;
    modal.querySelector('.mmu-close2').onclick = close;
    modal.querySelector('.mmu-later').onclick = close;
    modal.querySelector('.mmu-go').onclick = start;
    modal.querySelector('.mmu-again').onclick = start;
    modal.querySelector('.mmu-again2').onclick = start;
    modal.querySelector('.mmu-close3').onclick = close;
    // reload so the theme draws its own sold-out card, which can't be picked
    modal.querySelector('.mmu-close4').onclick = function () { close(); location.reload(); };
    modal.querySelector('.mmu-atc').onclick = function () { addToCart(this, 'win'); };
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }
  function screen(name) {
    [].forEach.call(modal.querySelectorAll('.mmu-screen'), function (s) { s.classList.toggle('is-on', s.classList.contains('mmu-' + name)); });
    var f = modal.querySelector('.mmu-' + name + ' .mmu-btn'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function open() {
    if (!modal) build();
    lastFocus = document.activeElement;
    modal.style.display = 'flex'; void modal.offsetWidth; modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    screen(soldShown ? 'soldout' : unlocked() ? 'win' : 'intro');
    track('mm_unlock_open', { attempts: attempts });
    if (!soldShown) inStock().then(function (ok) { if (!ok) soldOut('open'); });
  }
  // live stock check: the page's sellable flag is fixed at render, but the last set can go while it's open
  function inStock() {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    return fetch(root + 'products/' + (C.handle || 'christmas-monster-set') + '.js?mmu=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (p) { var v = (p.variants || []).find(function (x) { return x.id == C.variant; }); return v ? !!v.available : !!p.available; })
      .catch(function () { return true; });
  }
  function soldOut(via) {
    if (soldShown) return;
    soldShown = true; C.sellable = false;
    track('mm_unlock_soldout', { via: via });
    // turn the card into the theme's sold-out card right away, so it can't be picked even before the reload
    if (card) {
      if (cta) { cta.remove(); cta = null; }
      clearInterval(ticker); ticker = null;
      var radio = card.querySelector('input[type="radio"]'); if (radio) radio.disabled = true;
      card.classList.remove('mmu-held'); card.classList.add('is-sold');
      setText(card, 'locked', 'Sold out'); setText(card, 'unlocked', 'Sold out');
      var status = [].find.call(card.querySelectorAll('div'), function (d) { return /catch neon jack|yours for|locked|unlocked/i.test(d.textContent) && d.children.length <= 2 && d.querySelector('strong'); });
      if (status) status.innerHTML = '<strong>Sold out</strong> · every set is taken';
      unpickSet();
    }
    if (!modal) build();
    endRound(true);
    if (!modal.classList.contains('is-open')) { modal.style.display = 'flex'; void modal.offsetWidth; modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    screen('soldout');
  }
  function close() {
    endRound(true);
    modal.classList.remove('is-open');
    setTimeout(function () { modal.style.display = 'none'; }, 200);
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- game ---------- */
  var G = null;
  function start() {
    if (soldShown) return;
    inStock().then(function (ok) { if (!ok) soldOut('start'); });
    attempts++;
    // each retry: monsters stay up longer and Neon Jack shows up more often (spawn speed stays the same,
    // otherwise fewer Jacks appear and retries get harder)
    var ease = Math.min(1 + 0.15 * (attempts - 1), 1.6);
    G = { caught: 0, left: SECONDS * 1000, up: 1000 * ease * (reduced ? 1.3 : 1), gap: 600, p: Math.min(0.5 + 0.07 * (attempts - 1), 0.75), sinceJack: 0, timers: [], live: false };
    [].forEach.call(modal.querySelectorAll('.mmu-pip'), function (p) { p.classList.remove('is-on'); });
    [].forEach.call(modal.querySelectorAll('.mmu-hole'), function (h) { h.className = 'mmu-hole'; });
    tick(G.left);
    screen('play');
    track('mm_unlock_start', { attempt: attempts });
    var cnt = modal.querySelector('.mmu-count'), n = 3;
    cnt.textContent = n;
    var cd = setInterval(function () {
      n--; cnt.textContent = n > 0 ? n : '';
      if (n <= 0) { clearInterval(cd); G.live = true; G.last = performance.now(); spawn(); G.timers.push(setInterval(loop, 50)); }
    }, 650);
    G.timers.push(cd);
  }
  function loop() {
    if (!G || !G.live) return;
    var now = performance.now();
    G.left -= now - G.last; G.last = now;
    tick(G.left);
    if (G.left <= 0) lose();
  }
  function tick(ms) {
    var t = modal.querySelector('.mmu-time'), s = Math.max(0, ms) / 1000;
    t.textContent = s.toFixed(1) + 's';
    t.classList.toggle('is-low', G && G.live && s < 4);
    modal.querySelector('.mmu-bar i').style.transform = 'scaleX(' + Math.max(0, s / SECONDS) + ')';
  }
  function spawn() {
    if (!G || !G.live) return;
    var holes = [].filter.call(modal.querySelectorAll('.mmu-hole'), function (h) { return !h.classList.contains('is-up'); });
    if (holes.length) {
      var h = holes[Math.floor(Math.random() * holes.length)];
      var jack = G.sinceJack >= 2 || Math.random() < G.p; // never more than 2 decoys in a row
      G.sinceJack = jack ? 0 : G.sinceJack + 1;
      var who = jack ? 'jack' : (Math.random() < 0.5 ? 'lemmy' : 'medusa');
      h.querySelector('img').src = IMG[who];
      h.dataset.who = who;
      h.className = 'mmu-hole is-up' + (jack ? ' is-jack' : '');
      var hide = setTimeout(function () { h.classList.remove('is-up'); }, G.up * (0.85 + Math.random() * 0.3));
      G.timers.push(hide);
    }
    G.timers.push(setTimeout(spawn, G.gap * (0.75 + Math.random() * 0.5)));
  }
  function pop(h, txt, cls) {
    var p = el('span', 'mmu-pop ' + cls, txt); h.appendChild(p); setTimeout(function () { p.remove(); }, 700);
  }
  function hit(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (!G || !G.live || !this.classList.contains('is-up')) return;
    this.classList.remove('is-up');
    if (this.dataset.who === 'jack') {
      G.caught++;
      modal.querySelectorAll('.mmu-pip')[G.caught - 1].classList.add('is-on');
      pop(this, '+1', 'ok');
      if (navigator.vibrate) try { navigator.vibrate(18); } catch (x) {}
      if (G.caught >= GOAL) win();
    } else {
      G.left -= PENALTY * 1000;
      pop(this, '−' + PENALTY + 's', 'no');
      var b = modal.querySelector('.mmu-board'); b.classList.remove('is-shake'); void b.offsetWidth; b.classList.add('is-shake');
    }
  }
  function endRound(abort) {
    if (!G) return;
    G.live = false;
    G.timers.forEach(function (t) { clearTimeout(t); clearInterval(t); });
    if (abort) { modal.querySelector('.mmu-count').textContent = ''; G = null; }
  }
  function win() {
    var ms = Math.round(SECONDS * 1000 - G.left);
    endRound();
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    track('mm_unlock_win', { attempt: attempts, ms: ms });
    setTimeout(function () { screen('win'); confetti(); paintCard(); startTicker(); }, 350);
  }
  function lose() {
    var c = G.caught;
    endRound(); tick(0);
    track('mm_unlock_lose', { attempt: attempts, caught: c });
    modal.querySelector('.mmu-score').textContent = 'Time’s up · ' + c + ' of ' + GOAL + ' caught';
    setTimeout(function () { screen('lose'); }, 400);
  }
  function confetti() {
    if (reduced) return;
    var box = el('div', 'mmu-confetti'), cols = ['#b6ff3b', '#c8102e', '#f4efe6', '#ff30cc', '#1f5a3a'];
    for (var i = 0; i < 70; i++) {
      var p = el('i'); p.style.left = Math.random() * 100 + '%'; p.style.background = cols[i % cols.length];
      p.style.animationDelay = Math.random() * 0.5 + 's'; p.style.animationDuration = 1.4 + Math.random() * 1.2 + 's';
      box.appendChild(p);
    }
    modal.querySelector('.mmu-panel').appendChild(box); setTimeout(function () { box.remove(); }, 3200);
  }

  /* ---------- cart ---------- */
  function addToCart(btn, from) {
    var note = modal && modal.querySelector('.mmu-note');
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var preview = window.Shopify && Shopify.theme && Shopify.theme.role !== 'main';
    if (!unlocked()) { if (modal && modal.classList.contains('is-open')) screen('expired'); else open(); return; }
    track('mm_unlock_atc', { from: from, secondsLeft: Math.round(left() / 1000) });
    if (C.dryRun || (C.sellable === false && preview)) {
      btn.textContent = 'Added ✓ (' + (C.dryRun ? 'local test' : 'preview') + ')';
      if (note) note.textContent = C.dryRun ? 'Local preview: on the live site this adds variant ' + C.variant + ' to the cart and opens the cart drawer.'
        : 'Preview only: no Christmas Sets are released yet, so nothing went in your cart. Once sets are loaded, this adds one and opens the cart.';
      return;
    }
    if (C.sellable === false) { soldOut('atc'); return; }
    btn.disabled = true; btn.textContent = 'Adding…';
    var drawer = document.querySelector('custom-cart-drawer'), sid = drawer && drawer.dataset.sectionId;
    var body = { items: [{ id: C.variant, quantity: 1, properties: { _unlocked_by: 'catch-neon-jack' } }] };
    if (sid) body.sections = sid;
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        if (modal && modal.classList.contains('is-open')) close();
        btn.disabled = false; btn.textContent = 'Added ✓';
        // the theme's cart drawer redraws from cart:rerender when the add response carries its section HTML
        if (sid && res.sections) window.dispatchEvent(new CustomEvent('cart:rerender', { detail: { cart: { sections: res.sections }, open: true } }));
        else location.href = root + 'cart';
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = 'Add to cart · ' + (C.price || '$199');
        if (note) note.textContent = (err && (err.description || err.message)) || 'Couldn’t add it. Try again in a moment.';
        inStock().then(function (ok) { if (!ok) soldOut('atc_error'); });
      });
  }

  /* ---------- boot ---------- */
  function boot() {
    try {
      if (/[?&]mmu_reset=1/.test(location.search)) try { localStorage.removeItem(KEY); } catch (e) {}
      card = document.querySelector(C.cardSelector || '[data-card="set"]');
      if (!card || card.dataset.mmu) return;
      card.dataset.mmu = '1';
      // sold out: leave the theme's own sold-out card alone (it can't be picked), no lock, no game
      if (C.sellable === false || card.classList.contains('is-sold')) { track('mm_unlock_view', { soldout: true }); return; }
      paintCard();
      if (window.customElements) customElements.whenDefined('blind-box-offer').then(guardOffer);
      track('mm_unlock_view', { unlocked: !!unlocked() });
      // arriving from the locked product page's "Play to unlock" button: go straight to the game
      if (location.hash === '#play-unlock' && !unlocked()) { card.scrollIntoView({ block: 'center' }); setTimeout(open, 500); }
    } catch (e) { if (C.debug) console.error('[mmu]', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.MMU.reset = function () { try { localStorage.removeItem(KEY); } catch (e) {} clearInterval(ticker); ticker = null; if (card) paintCard(); };
})();
